<template>
  <div id="nav">
    <div class="left">
      <div class="company">星络云物联平台</div>
      <div style="text-align:center" @click="foldToggle">
        <i :class=" ['icon', opened == true? 'el-icon-s-unfold' : 'el-icon-s-fold' ]"></i>
      </div>
      <!--  <div>展开</div>  -->
    </div>
    <div class="right">
      <div class="name">{{regName}}</div>
      <div class="quit" @click="quit">退出</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { logout } from '@/api/login'
export default {
  name: 'NavBar',
  data () {
    return {
      isOpen: false,
      regName: ''
    }
  },
  computed: {
    // ...mapGetters(['opened', 'regName'])
    ...mapGetters(['opened'])
  },
  mounted () {
    this.regName = localStorage.getItem('userName')
    this.$store.commit('SET_OPENED', this.isOpen)
    // console.log('this.opened', this.opened)
  },
  methods: {
    quit () {
      this.$confirm('确认退出当前帐号, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        logout().then((res) => {
          if (res.data.code === 200 || res.data.code === 0) {
            this.$message({
              type: 'success',
              message: '登出成功'
            })
            sessionStorage.clear()
            localStorage.clear()
            this.$store.commit('REMOVE_TOKEN', '')
            this.$router.push('/login')
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消退出'
        })
      })
    },
    foldToggle () {
      this.isOpen = !this.isOpen
      this.$store.commit('SET_OPENED', this.isOpen)
    }
  }
}
</script>

<style lang="less" scoped>
  .quit {
    cursor: pointer;
  }
  #nav {
    background-color: lightslategray;
    // background-color: #2a6db1f5;
    color: white;
    line-height: 60px;
    padding: 0 30px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 16px;
    .left, .right {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      font-size: 20px;
      .icon{
        cursor: pointer;
      }
    }

    .company,.name {
      margin-right: 20px;
    }
  }
</style>
